import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function appListReducer(state = initialState.appList, action) {
  if (action.type === types.LOAD_APP_LIST_SUCCESS) {
    return action.appList;
  } else {
    return state;
  }
}
